module.exports = __webpack_public_path__ + "img/banner_2.0f1f080e.jpg";